<template>
  <div
    id="sales-modal"
    :class="isGeneralStyle ? 'general' : 'alternative'"
    :style="getBackground"
  >
    <template v-if="hasUserTimerAndMinutes">
      <div class="modal-icon">
        <img src="/static/img/salesTimerIcon.svg" />
      </div>
    </template>
    <template v-else>
      <img
        v-if="upperPicture && !isReSubscription"
        :src="upperPicture"
        class="upper-picture"
      />
      <div v-else-if="isReSubscription" class="upper-section">
        <div style="position:relative">
          <div class="upper-msg-cont">
            <div class="upper-msg">
              {{ $t("app.reSubscription.upperPicture.goodbyeText") }}
            </div>
          </div>
          <img src="/static/img/sales/professor-renew.svg" />
        </div>
      </div>
      <div class="modal-icon" ref="modal-icon" v-else>
        <!-- <div class="crown" v-if="needRotatedCrown">
        <icon-crown />
      </div>-->
        <div class="main" v-if="!teacherPicture">
          <component :is="mainIconComponent" />
        </div>
        <div class="main" v-if="teacherPicture">
          <img
            :src="teacherPicture"
            class="teacher-image"
            height="70"
            width="70"
          />
        </div>
      </div>
    </template>
    <div
      class="modal-title"
      :style="isPurchaseCancel ? 'padding-bottom: 16px !important' : ''"
      v-html="$t(getComputedTitle)"
    ></div>
    <template v-if="hasUserTimerAndMinutes">
      <div
        class="modal-subtitle"
        :style="isPurchaseCancel ? 'width:auto;padding-bottom:28px' : ' '"
      >
        <p v-html="$t('app.baseSalesModal.timer.description')"></p>
        <p class="counter">
          {{ formattedEndDate }}
        </p>
      </div>
    </template>
    <template v-else>
      <div
        class="modal-subtitle"
        :style="isPurchaseCancel ? 'width:auto;padding-bottom:28px' : ' '"
      >
        <p v-html="getDescriptionText"></p>
      </div>
    </template>
    <div
      class="row no-gutters justify-content-center"
      v-if="!this.classroomPro"
    >
      <span class="button-label">
        {{ getButtonLabel }}
        <inline-link v-if="hasDiscount && !this.classroomPro" class="more-about-price" :text="$t('app.priceCommunication.link.text')" @inlineLinkClicked="openPriceCommunication(product)"/>
      </span>
    </div>
    <div
      class="cta-wrapper row no-gutters btn"
      :style="hasDiscount ? 'position: relative' : ''"
    >
      <rounded-button
        @click.native="okActionClicked"
        :text="getOkButtonText"
        :isTextVhtml="isOkButtonTextHtml"
        :state="isLoading ? 'loading' : 'enabled'"
        :fontSize="'16px'"
        :fontWeight="'bold'"
        :color="'#fab62f'"
        class="first-btn-fix"
      />
      <discount-label
        v-if="hasDiscount && !this.classroomPro"
        :text="getDiscountPercentageText"
        :rotateValue="5"
        :textColor="'#333333'"
        :padding="'0 0 0 10px'"
        :labelHeight="31"
        :labelWidth="75"
        :rightSideBackgroundColor="isReSubscription ? 'blue' : 'white'"
        :isRotated="true"
        :isLeftSide="false"
        class="label"
      />
    </div>
    <div
      class="row no-gutters btn find-more-about"
      v-if="needFindOutMoreButton"
    >
      <rounded-button
        @click.native="findOutMore"
        :text="'app.proModal.teachbot.findMoreAboutPro.text'"
        :state="'enabled'"
        :fontSize="'16px'"
        :fontWeight="'bold'"
        :color="'#fab62f'"
        :isOutline="true"
        class="first-btn-fix"
      />
    </div>
    <div class="modal-cancel">
      <inline-link
        @inlineLinkClicked="cancelAction"
        :text="$t(cancelText)"
        :isDisabled="false"
        :color="'#ffffff'"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PriceCommunicationModal from '@/components/shared/elements/modal/PriceCommunicationModal';
import RoundedButton from '@/components/shared/elements/buttons/RoundedButton';
import LoaderRing from '@/components/shared/elements/loaders/LoaderRing';
import DiscountLabel from '@/components/shared/elements/modal/DiscountLabel';
import ShimmingLine from '@/components/shared/elements/shimming/ShimmingLine';
import FindOutMorePro from '@/components/modules/island/components/FindOutMorePro';
import InlineLink from '@/components/shared/elements/buttons/InlineLink';
import ProductsContentMixin from '@/components/shared/elements/mixins/ProductsContentMixin';
import TimerMixin from '@/components/shared/elements/mixins/TimerMixin';

const IconCrown = () => import('@/components/shared/elements/icons/IconCrown');

export default {
  name: 'SalesBaseModal',
  mixins: [ProductsContentMixin, TimerMixin],
  components: {
    'rounded-button': RoundedButton,
    'icon-crown': IconCrown,
    LoaderRing,
    DiscountLabel,
    'shimming-line': ShimmingLine,
    FindOutMorePro,
    'inline-link': InlineLink,
    PriceCommunicationModal,
  },
  watch: {
    timerEndCountdown() {
      if (this.timerEndCountdown <= 0) {
        this.removeTimerInterval();
      }
    },
  },
  computed: {
    ...mapGetters({
      getLang: 'settings/userSelectedLanguage',
      loggedInUserProfile: 'users/loggedInUserProfile',
      isTimerAvailable: 'users/isTimerAvailable',
      hasTimerUserMinutes: 'users/hasTimerUserMinutes',
    }),
    hasUserTimerAndMinutes() {
      return !this.hasTimerUserMinutes && this.isTimerAvailable;
    },
    formattedEndDate() {
      const date = this.timerEndCountdown <= 0 ? 0 : this.timerEndCountdown;
      return this.formatMsToHourMinSec(date);
    },
    getComputedTitle() {
      return this.hasUserTimerAndMinutes
        ? 'app.baseSalesModal.timer.title'
        : this.titleText;
    },
    isPurchaseCancel() {
      return this.titleText == 'app.sales.popups.purchaseCancel.title';
    },
    getBackground() {
      if (this.isReSubscription) {
        return { backgroundColor: '#2e73a1' };
      }
      return {
        backgroundImage: 'linear-gradient(to bottom, var(--primaryBlue), #24587c)',
      };
    },
  },
  props: {
    upperPicture: {
      type: [String, Function],
      required: false,
    },
    teacherPicture: {
      type: [String, Function],
      required: false,
    },
    mainIconComponent: {
      type: [Object, Function],
      required: true,
    },
    needRotatedCrown: {
      type: Boolean,
      required: false,
      default: true,
    },
    titleText: {
      type: String,
      required: true,
    },
    descriptionText: {
      type: String,
      required: true,
    },
    okText: {
      type: String,
      required: true,
    },
    cancelText: {
      type: String,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    cancelAction: {
      type: Function,
      required: true,
    },
    needFindOutMoreButton: {
      type: Boolean,
      required: true,
    },
    isGeneralStyle: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      getProduct: 'subscriptions/getProduct',
      getUserProfile: 'users/getUserProfile',
      setProPopupType: 'settings/setProPopupType',
    }),
    openPriceCommunication(product) {
      this.$eventBus.showModal({
        bind: {
          is: PriceCommunicationModal,
          product,
          monthlyProduct: this.currentProducts[0],
          currency: this.currency,
          discountText: `${this.product.discountPercentage}%`,
        },
      });
    },
    createTimerInterval() {
      if (this.hasUserTimerAndMinutes && this.timerInterval == null) {
        this.timerInterval = setInterval(() => {
          this.countingEndCounter();
        }, 1000);
      }
    },
    removeTimerInterval() {
      if (this.hasUserTimerAndMinutes && this.timerInterval != null) {
        window.clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    saveProPopup() {
      this.setProPopupType(this.type);
    },
    okActionClicked() {
      this.saveProPopup();
      this.okAction(this.product);
    },
    findOutMore() {
      this.$router.push('/pro');
      this.$eventBus.closeModal();
      // this.$eventBus.showModal({
      //   bind: {
      //     is: FindOutMorePro,
      //     okBtnText: this.usedTrial
      //       ? this.getOkButtonText
      //       : this.$t('app.findOutMorePro.startFreeTrial'),
      //     isOkButtonTextHtml: this.isOkButtonTextHtml,
      //     product: this.product,
      //     countryPrice: this.getCountryPrice,
      //     buttonLabel: this.getButtonLabel,
      //     okAction: this.okActionClicked,
      //     hasDiscount: this.hasDiscount,
      //     discountPercentAge: this.hasDiscount
      //       ? this.getDiscountPercentageText
      //       : '',
      //   },
      // });
    },
    popupType(title) {
      switch (title) {
        case 'app.sales.popups.favourite.title': {
          this.proPopupEventActionName = 'FAVOURITES_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.grammar.title': {
          this.proPopupEventActionName = 'GRAMMAR_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.expressionTags.title': {
          this.proPopupEventActionName = 'EXPRESSION_CATEGORIES_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.catalog.title': {
          this.proPopupEventActionName = 'CATALOGUE_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.profileAvatar.title': {
          this.proPopupEventActionName = 'PROFILE_AVATAR_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.testAvatar.title': {
          this.proPopupEventActionName = 'PROF_TEST_THEMES_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.miniGrammar.title': {
          this.proPopupEventActionName = 'MINI_GRAMMAR_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.resubSales.title': {
          this.proPopupEventActionName = 'Special offer';
          this.isProPopup = true;
          this.isRenewPro = true;
          break;
        }
        case 'app.sales.popups.speakbot.title': {
          this.proPopupEventActionName = 'SPEAK_BOT_TALK_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.speakbotLearningWords.title': {
          this.proPopupEventActionName = 'SPEAK_BOT_EXP_LEARNER_PRO';
          this.isProPopup = true;
          break;
        }
        case 'app.sales.popups.classroomProContentClicked.title': {
          this.proPopupEventActionName = 'CLASSROOM_PRO';
          this.isProPopup = true;
          this.classroomPro = true;
          break;
        }
        default: {
        }
      }
    },
    sendAnalytics() {
      if (this.isProPopup) {
        if (!this.isRenewPro) {
          // gtag measurement point
          if (this.$gtag) {
            this.$gtag.event(this.proPopupEventActionName, {
              event_category: 'PRO offer',
              event_label: 'Trial',
            });
          }
        } else if (this.$gtag) {
          // gtag measurement point
          this.$gtag.event(this.proPopupEventActionName, {
            event_category: 'renew PRO',
            event_label: this.product.analyticKey,
          });
        }
      }
    },
    sendFacebookAnalytics() {
      if (this.isProPopup) {
        if (!this.isRenewPro) {
          if (typeof fbq !== 'undefined') {
            fbq('trackCustom', this.proPopupEventActionName, {
              eventCategory: 'PRO offer',
              eventLabel: 'Trial',
            });
          }
        } else if (typeof fbq !== 'undefined') {
          fbq('trackCustom', this.proPopupEventActionName, {
            eventCategory: 'renew PRO',
            eventLabel: this.product.analyticKey,
          });
        }
      }
    },
  },
  data() {
    return {
      isProPopup: false,
      proPopupEventActionName: undefined,
      isRenewPro: false,
      classroomPro: false,
      timerInterval: null,
    };
  },
  async created() {
    this.popupType(this.titleText);
    this.sendAnalytics();
    this.sendFacebookAnalytics();
    if (this.hasUserTimerAndMinutes) {
      this.createTimerInterval();
    }
  },
  mounted() {
    if (this.$route.name === 'ClassroomDetailsScreen') {
      this.$refs['modal-icon'].style.paddingBottom = '22.6px';
    }
  },
  beforeDestroy() {
    this.removeTimerInterval();
  },
};
</script>

<style lang="scss" scoped>
#sales-modal {
  width: 312px;
  padding: 1.5rem;
  color: var(--white);
  overflow: visible;
  border-radius: 8px;
  .upper-picture {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 0;
    transform: translateY(-90%);
    z-index: -1;
    max-width: 132.5px;
  }
  .modal-icon,
  .modal-title,
  .modal-subtitle,
  .modal-cancel {
    text-align: center;
    cursor: pointer;
  }

  .first-btn-fix {
    /deep/ .btn-text {
      font-size: 16px;
      line-height: 16px;
      white-space: normal;
      display: flex;
    }
    /deep/ .button-wrapper {
      height: 44px;
    }
  }
  .second-btn-fix {
    /deep/ .btn-text {
      padding-top: 9px;
      padding-bottom: 9px;
    }
    /deep/ .btn {
      border-width: 1px !important;
    }
  }
}
#sales-modal.need-min-height {
  min-height: 360px;
}
.find-more-about {
  padding-bottom: 23px;
}

.more-about-price {
  height: 12px !important;
  margin: 0px auto 8px auto;
  width: fit-content;
  align-content: center;
  /deep/ .link {
    font-size: 12px;
    line-height: 1.17;
    font-weight: normal;
    color: var(--white) !important;
  }
  :hover {
    text-decoration: unset !important;
  }
}

.button-label {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
}

.general {
  .modal-title {
    /deep/ p {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.3;
      min-height: 52px;
    }
    padding: 16px 0 0.5rem 0 !important;

    /deep/ img {
      border-radius: 2px;
      width: 64px;
      height: 26.8px;
    }
  }

  .cta-wrapper {
    padding: 13px 0 24px 0;
  }

  .modal-subtitle {
    p {
      font-size: 16px;
      line-height: 1.38;
      padding: 0 5px;
    }
    padding-bottom: 24px;
  }

  .label {
    position: absolute;
    top: 0px;
    right: -20px;
  }

  .modal-icon {
    position: relative;
    margin: 0 auto;
    padding-top: 10px;
    .crown {
      position: absolute;
      transform: rotate(-42deg);
      width: 53px;
      top: 4.5%;
      left: 30%;
    }
    .main {
      svg {
        width: 72px;
        height: 72px;
      }
    }
  }
}

.alternative {
  .modal-icon {
    position: relative;
    margin: 0 auto;
    padding-bottom: 37.7px;
    .crown {
      position: absolute;
      transform: rotate(-42deg);
      width: 53px;
      top: 4.5%;
      left: 30%;
    }
    .main svg {
      width: auto;
      height: auto;
    }
  }

  .label {
    position: absolute;
    top: 0px;
    right: -20px;
  }
  .modal-title {
    width: 258px;
    margin: 0 auto;
    padding-top: 0px !important;
    padding-bottom: 8px;
    font-family: Roboto;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: var(--white);
  }

  .modal-subtitle {
    width: 236px;
    margin: 0 auto;
    p {
      padding: 0 5px;
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
    }
    padding-bottom: 24px;
  }

  .cta-wrapper {
    padding: 13px 0 24px 0 !important;
  }

  .upper-section {
    width: 265px;
    top: 102px;
    right: 37px;
    position: absolute;
    margin: 0 auto;
    transform: translateY(-90%);
    z-index: -1;
    .upper-msg-cont {
      top: 0;
      left: 10px;
      position: absolute;
      width: 132px;
      height: 122px;
      display: flex;
      align-items: center;
      justify-content: center;
      .upper-msg {
        font-family: Roboto;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        font-style: italic;
        line-height: 1.2;
        letter-spacing: -0.3px;
        text-align: left;
        color: var(--white);
        width: 99px;
      }
    }
  }
}
.teacher-image {
  border-radius: 100%;
  object-fit: cover;
}
.first-btn-fix {
  /deep/ .btn-text {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media (max-width: $medium-screen) {
  #sales-modal {
    width: 280px;
    .modal-title {
      width: 100%;
    }
    .label {
      top: -4px;
    }
  }
}
</style>
